<template>
  <!-- Main Content -->
  <div class="page-wrapper">
    <div class="container-fluid">
      <!-- Title -->
      <div class="row heading-bg">
        <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
          <h5 class="txt-dark">Upload Users</h5>
        </div>
        <!-- Breadcrumb -->
        <div class="col-lg-9 col-sm-8 col-md-8 col-xs-12">
          <ol class="breadcrumb">
            <li><router-link to="/">Dashboard</router-link></li>
            <li>Data Center</li>
            <li class="active">Upload Users</li>
          </ol>
        </div>
        <!-- /Breadcrumb -->
      </div>
      <!-- /Title -->

      <!-- Row -->
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                &nbsp;&nbsp;
                <a
                  :href="`${mediaUrl}samples/user-sample-data.xlsx`"
                  target="_blank"
                >
                  [ Download Sample Excel ]
                </a>

                <input
                  type="file"
                  id="file"
                  name="file"
                  ref="file"
                  accept="application/ms-excel"
                  multiple
                />
                <br />
                <a href="javascript:void" @click="truncatePendingDocuments"
                  >Truncate List</a
                >
                <br /><br />
                <span style="color: red"> {{ message }} </span>
                <span v-if="isLoading"> Uploading...</span>

                <div class="form-footer" v-if="crudUsers.length == 0">
                  <button
                    class="btn btn-primary btn-block"
                    @click="handleFileUpload"
                  >
                    Upload file
                  </button>
                </div>

                <div class="form-footer" v-else>
                  <button
                    class="btn btn-success btn-block"
                    @click="processFile"
                  >
                    Process file
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Row -->

      <!-- Row -->
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="table-wrap">
                  <table class="table table-hover table-striped">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Employee NAME</th>
                        <th>EMPL ID</th>
                        <th>EMAIL</th>
                        <th>DOB</th>
                        <th>BLOOD GROUP</th>
                        <th>FATHER NAME</th>
                        <th>MARITAL STATUS</th>
                        <th>MARRIAGE DATE</th>
                        <th>SPOUSE NAME</th>
                        <th>NATIONALITY</th>
                        <th>RESIDENTIAL STATUS</th>
                        <th>PLACE OF BIRTH</th>
                        <th>COUNTRY ORIGIN</th>
                        <th>RELIGION</th>
                        <th>IS INTERNATIONAL EMPLOYEE</th>
                        <th>IS PHYSICALLY CHALLENGED</th>
                        <th>IS DIRECTOR</th>
                        <th>VERIFICATION STATUS</th>
                        <th>VETIFICATION ON</th>
                        <th>AGENCY NAME</th>
                        <th>REMARKS</th>
                        <th>JOINED ON</th>
                        <th>CONFIRMATION DATE</th>
                        <th>EMPLOYEE STATUS</th>
                        <th>PROBATION PERIOD</th>
                        <th>NOTICE PERIOD</th>
                        <th>BANK NAME</th>
                        <th>BANK BRANCH</th>
                        <th>BANK ACC NO</th>
                        <th>BANK IFSC CODE</th>
                        <th>BANK ACC TYPE</th>
                        <th>BANK PAYMENT TYPE</th>
                        <th>NAME ON BANK</th>
                        <th>IS ESI APPICABLE</th>
                        <th>ESI NUMBER</th>
                        <th>IS PF APPLICABLE</th>
                        <th>UAN NO</th>
                        <th>PF NO</th>
                        <th>PF JOINING DATE</th>
                        <th>FAMILY PF NO</th>
                        <th>IS EXISTING MEMBER OF ESP</th>
                        <th>ALLOW EPF EXCESS CONTRIBUTION</th>
                        <th>ALLOW EPS EXCESS CONTRIBUTION</th>
                        <th>IS LWF APPICABLE</th>
                        <th>API TOKEN</th>
                        <th>EMAIL VERIFIED AT</th>
                        <th>MOBILE</th>
                        <th>GENDER</th>
                        <th>GROUP</th>
                        <th>GROUP DIVISION</th>
                        <th>IS RELIEVER</th>
                      </tr>
                    </thead>
                    <tbody>
                      <loading-table
                        :isLoading="isLoading"
                        cols="2"
                      ></loading-table>
                      <tr
                        v-for="(cruduser, at) in crudUsers"
                        :key="`cruduser${at}`"
                      >
                        <td>{{ serialNoStarting + at + 1 }}</td>
                        <td>{{ cruduser.full_name }}</td>
                        <td>{{ cruduser.employee_id }}</td>
                        <td>{{ cruduser.email }}</td>
                        <td>{{ cruduser.dob }}</td>
                        <td>{{ cruduser.blood_group }}</td>
                        <td>{{ cruduser.father_name }}</td>
                        <td>{{ cruduser.marital_status }}</td>
                        <td>{{ cruduser.marriage_date }}</td>
                        <td>{{ cruduser.spouse_name }}</td>
                        <td>{{ cruduser.nationality }}</td>
                        <td>{{ cruduser.residential_status }}</td>
                        <td>{{ cruduser.place_of_birth }}</td>
                        <td>{{ cruduser.country_origin }}</td>
                        <td>{{ cruduser.religion }}</td>
                        <td>{{ cruduser.is_international_employee }}</td>
                        <td>{{ cruduser.is_physically_challanged }}</td>
                        <td>{{ cruduser.is_director }}</td>
                        <td>{{ cruduser.verification_status }}</td>
                        <td>{{ cruduser.vetification_on }}</td>
                        <td>{{ cruduser.agency_name }}</td>
                        <td>{{ cruduser.remarks }}</td>
                        <td>{{ cruduser.joined_on }}</td>
                        <td>{{ cruduser.confirmation_date }}</td>
                        <td>{{ cruduser.employee_status }}</td>
                        <td>{{ cruduser.probation_period }}</td>
                        <td>{{ cruduser.notice_period }}</td>
                        <td>{{ cruduser.bank_name }}</td>
                        <td>{{ cruduser.bank_branch }}</td>
                        <td>{{ cruduser.bank_acc_no }}</td>
                        <td>{{ cruduser.bank_ifsc_code }}</td>
                        <td>{{ cruduser.bank_acc_type }}</td>
                        <td>{{ cruduser.bank_payment_type }}</td>
                        <td>{{ cruduser.name_on_bank }}</td>
                        <td>{{ cruduser.is_esi_applicable }}</td>
                        <td>{{ cruduser.esi_number }}</td>
                        <td>{{ cruduser.is_pf_applicable }}</td>
                        <td>{{ cruduser.uan_no }}</td>
                        <td>{{ cruduser.pf_no }}</td>
                        <td>{{ cruduser.pf_joining_date }}</td>
                        <td>{{ cruduser.family_pf_no }}</td>
                        <td>{{ cruduser.is_existing_member_of_eps }}</td>
                        <td>{{ cruduser.allow_epf_excess_contribution }}</td>
                        <td>{{ cruduser.allow_eps_excess_contribution }}</td>
                        <td>{{ cruduser.is_lwf_applicable }}</td>
                        <td>{{ cruduser.api_token }}</td>
                        <td>{{ cruduser.email_verified_at }}</td>
                        <td>{{ cruduser.mobile }}</td>
                        <td>{{ cruduser.gender }}</td>
                        <td>{{ cruduser.group }}</td>
                        <td>{{ cruduser.group_division }}</td>
                        <td>{{ cruduser.is_reliever }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Row -->
    </div>
  </div>
  <!-- /Main Content -->
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "uploadusers",
  data() {
    return {
      crudUsers: [],
      message: "",
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData(page = 1) {
      this.isLoading = true;
      let crudUsers = await axios.get(`/crude_users`);
      this.crudUsers = crudUsers.data.data;
      // console.log(this.crudUsers);
      this.count = crudUsers.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async handleFileUpload() {
      this.isLoading = true;
      this.users = this.$refs.file.files[0];
      let formData = new FormData();
      formData.append("usersData", this.users);
      await axios
        .post("upload_user", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.data) this.crudUsers = response.data.data;
          this.isLoading = false;
          // alert("Uploaded Successfully");
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
      this.isLoading = false;
    },
    async processFile() {
      try {
        this.isLoading = true;
        await axios.get("process_user");
        alert("Processed Successfully");
        await axios.get("truncate_users");
        this.crudUsers = [];
        this.isLoading = false;
      } catch (e) {
        console.log(e);
      }
    },
    async truncatePendingDocuments() {
      await axios.get("truncate_users");
      alert("Truncated Successfully");
      this.crudUsers = [];
    },
    async deleteDocument($id) {
      var r = confirm("Are you sure you want to delete the document!");
      if (r == true) {
        await axios.delete(`crude_users/${$id}`);
        this.crudUsers = this.crudUsers.filter((d) => d.id != $id);
      }
    },
  },
};
</script>
